import { LinearProgress, styled } from "@material-ui/core";
import _ from "lodash";
import qs from "query-string";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getInvestorsQuery } from "../ducks/selectors";
import InvestorTable from "../shared/components/InvestorTable";
import NoResults from "./NoResults";
import SeeMore from "./SeeMore";

const LoaderContainer = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2)
}));

const InvestorList = ({ isCompanyOwner }) => {
  const history = useHistory();
  const { search } = useLocation();
  const { page, per_page: perPage, ...queryParams } = qs.parse(search, {
    arrayFormat: "bracket"
  });

  const onSetPage = value => {
    history.push({
      search: qs.stringify(
        {
          ...queryParams,
          page: value + 1,
          per_page: perPage || 10
        },
        { arrayFormat: "bracket" }
      )
    });
  };

  const onSetPerPage = value => {
    history.push(
      { search: qs.stringify({ ...queryParams, page: 1, per_page: value }) },
      { arrayFormat: "bracket" }
    );
  };

  const {
    data: {
      data: investors,
      meta: { total }
    },
    loading: investorsLoading
  } = useSelector(getInvestorsQuery);

  if (investorsLoading) {
    return (
      <LoaderContainer>
        <LinearProgress />
      </LoaderContainer>
    );
  }

  if (_.isEmpty(investors)) {
    return <NoResults />;
  }

  return (
    <>
      <InvestorTable
        investors={investors}
        isPaginated
        isCompanyOwner={isCompanyOwner}
        page={+page - 1}
        perPage={+perPage}
        total={total}
        onSetPage={onSetPage}
        onSetPerPage={onSetPerPage}
      />
      <SeeMore />
    </>
  );
};

export default InvestorList;
